// extracted by mini-css-extract-plugin
module.exports = {"addBusinessCaseButtonRoot":"Button_addBusinessCaseButtonRoot__3uTEm","primary":"Button_primary__3Rolg","secondary":"Button_secondary__1itX3"};